export default "__VITE_ASSET__DCFZK$83__"